import { useSelector } from 'react-redux';

export default function useGetQuotationTemplate() {
  const url = useSelector(
    state => state.configuration?.content?.import_template_web
  );
  return [url];
}
